import { render, staticRenderFns } from "./ModuleLoader.vue?vue&type=template&id=2a9486fe&scoped=true&"
import script from "./ModuleLoader.vue?vue&type=script&lang=js&"
export * from "./ModuleLoader.vue?vue&type=script&lang=js&"
import style0 from "./ModuleLoader.vue?vue&type=style&index=0&id=2a9486fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9486fe",
  null
  
)

export default component.exports